import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M5 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM3.5 4a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1 6.5h-.125c-1.283 0-2.37.84-2.74 2H4.5a.75.75 0 0 1 0 1.5H.625A.625.625 0 0 1 0 13.375 4.375 4.375 0 0 1 4.375 9H4.5a.75.75 0 0 1 0 1.5Zm9.123-1.67v1.23c.4.127.749.372.996.7.247.33.38.725.381 1.13v1.189c0 .51-.21.998-.584 1.358a2.03 2.03 0 0 1-1.409.563H9.993a2.03 2.03 0 0 1-1.41-.563A1.887 1.887 0 0 1 8 13.08v-1.19c0-.407.135-.803.384-1.132a1.998 1.998 0 0 1 1-.699V8.83c0-.483.198-.946.551-1.289A1.934 1.934 0 0 1 11.268 7h.45c.504 0 .987.193 1.344.536.358.343.56.808.561 1.295Zm-3.166 1.104h2.08V8.832a.776.776 0 0 0-.243-.554.835.835 0 0 0-.577-.229h-.449a.827.827 0 0 0-.574.23.769.769 0 0 0-.238.553v1.104Z';
const draw24px =
  'M9.64,11.13a4.23,4.23,0,1,1,4.23-4.22A4.23,4.23,0,0,1,9.64,11.13Zm0-7a2.73,2.73,0,1,0,2.73,2.73A2.72,2.72,0,0,0,9.64,4.18Zm1.81,15.3a.76.76,0,0,0-.75-.75H2.79c.24-2.36,1.64-3.9,3.62-3.9H12a.75.75,0,0,0,0-1.5H6.41c-3,0-5.15,2.53-5.15,6.15a.74.74,0,0,0,.75.75H10.7A.75.75,0,0,0,11.45,19.48Zm9.4-3.8V13.92a2.63,2.63,0,0,0-2.63-2.62H17.6A2.62,2.62,0,0,0,15,13.92v1.76a2.76,2.76,0,0,0-1.91,2.62V20a2.75,2.75,0,0,0,2.75,2.75H20A2.75,2.75,0,0,0,22.75,20V18.3A2.76,2.76,0,0,0,20.85,15.68Zm-1.5-.13H16.48V13.92A1.12,1.12,0,0,1,17.6,12.8h.62a1.13,1.13,0,0,1,1.13,1.12Z';
const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const PersonLockIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'personLock'),
) as IconWithRender;

PersonLockIcon.displayName = 'PersonLockIcon';
PersonLockIcon.propTypes = Icon.propTypes;
PersonLockIcon.renderIcon = (props) => <PersonLockIcon {...props} />;
export default PersonLockIcon;
